import { AppState } from "../store";

export const categoriesSelector = (state: AppState) => state.categoryReducer